Vue.component('streamer_community_leaderboard', {
  template: templates.streamersCommunityLeaderBoard,
  data() {
    return {
      model: {
        users: [],
        top: [],
        medals: [],
        isLoggedIn: false,
        community: [],
        communityTop: [],
        tab: null,
        selectedStreamer: {},
        teams: [],
        topTeams: [],
        selectedOption: 0,
        memberCount: 4,
        options: [
          { value: 'Squad', name: 'Squad' },
          { value: '2v2', name: '2v2' },
          { value: '3v3', name: '3v3' },
          { value: '4v4', name: '4v4' }
        ],
      }
    }
  },
  mounted() {
    const c = this;
    c.get();
  },
  methods: {
    async get() {
      const c = this;

      try {
        const leaderboardResponse = await userService.getStreamersLeaderboard();
        c.model.users = leaderboardResponse.data;

        // Filter out users with null user property
        c.model.users = c.model.users.filter(user => user.user !== null);

        // Continue with the rest of your logic...
        const updatedUsers = [];

        const userPromises = c.model.users.map((userEntry) => {
            return new Promise((resolve) => {
                c.getCurrentTwitchInfo(userEntry.user[0].twitchId, function(user) {
                    if (user) {
                        // Update user with Twitch info and keep user
                        userEntry.user[0] = {
                            twitchId: user.twitchId,
                            twitchDisplayName: user.twitchDisplayName,
                            twitchProfileImage: user.twitchProfileImage
                        };
                        updatedUsers.push(userEntry);
                    }
                    resolve();
                });
            });
        });

        await Promise.all(userPromises);

        // Replace the original users array with filtered and updated users
        c.model.users = updatedUsers;

        // Set the top users based on filtered list
        if (c.model.users.length >= 3) {
            const [first, second, third] = c.model.users;
            c.model.top = [second, first, third];
        } else {
            c.model.top = [...c.model.users];
        }
        c.model.isLoggedIn = true;
    } catch (error) {
        c.model.isLoggedIn = false; 
          console.log('Error fetching leaderboard faction:', error);
      }
        
      console.log(c.model)
  },
    getTwitchInfo(data) {
      const c = this;

      const twitchIds = data.map(item => ({ twitchId: item.twitchId }));


      twitchAPI.getUsersById(twitchIds, function(userData) {
        for (let d of userData) {
  
          let user = {
            twitchId: d.id,
            twitchDisplayName: d.display_name,
            twitchProfileImage: d.profile_image_url
          }


          const match = data.find(item => item.twitchId === user.twitchId);
          c.model.users.push(match)
          if (match) {
            // Step 5: Update the matched entry with user information
            // match.twitchDisplayName = user.twitchDisplayName;
            // match.twitchProfileImage = user.twitchProfileImage;
            match.twitchDisplayName = user.twitchDisplayName;
            match.twitchProfileImage = user.twitchProfileImage;
          } 

        }
      });
      
    },
    getCurrentTwitchInfo(data, callback) {
      const c = this;
      twitchAPI.getUsersById([{ twitchId: data }], function(userData) {
        if (userData && userData.length > 0) {
          let user = {
            twitchId: userData[0].id,
            twitchDisplayName: userData[0].display_name,
            twitchProfileImage: userData[0].profile_image_url
          };
          callback(user); // Call the callback with the user data
        } else {
          callback(null); // Call the callback with null if no user data is found
        }
      });
    },
    showCommunity(id){
      const c = this;
      c.model.isLoggedIn = false
      c.getSelectedTwitchInfo(id);
      c.getStreamersCommunityTeam(id);
      c.model.twitchId = id;

      c.model.tab = 'single';
      const header = document.querySelector('.header');
      header.classList.toggle('z-index-zero'); 

      $('.streamers-community').addClass('is-above').addClass('is-visible');
      // c.getStreamersCommunity(id);
    },
    closeModal(){
      const c = this;
      $('.streamers-community').removeClass('is-above').removeClass('is-visible');
      const header = document.querySelector('.header');
      header.classList.toggle('z-index-zero'); 
      c.model.selectedStreamer = {};
      c.model.community = [];
      c.model.communityTop = [];


      console.log(c.model)
    },
    async getStreamersCommunityTeam(id){
      const c = this;

      try {
        const response = await userService.getStreamersCommunityLeaderboardTeam(id);
    
        c.model.teams = response.data;

        c.model.teams = c.model.teams.filter(team => 
          team.members && team.members.length > 0 && 
          team.members.every(memberArray => memberArray && memberArray.length > 0)
        );

        const memberPromises = [];
    
        c.model.teams.forEach((team) => {
            team.members.forEach((memberArray, memberIndex) => {
                const member = memberArray[0];
                const promise = new Promise((resolve) => {
                    c.getCurrentTeamTwitchInfo(member, member.twitchId, function(user) {
                        if (user) {
                            team.members[memberIndex] = {
                                ...member,
                                twitchDisplayName: user.twitchDisplayName,
                                twitchProfileImage: user.twitchProfileImage
                            };
                        }
                        resolve(); 
                    });
                });
                memberPromises.push(promise);
            });
        });

        await Promise.all(memberPromises);

   
        const first = response.data[0] || null;
        const second = response.data[1] || null;
        const third = response.data[2] || null;
        c.model.topTeams = [second, first, third];
        c.model.isLoggedIn = true
      } catch (error) {
          console.error("Error fetching team leaderboard:", error);
      }
    },
    async getStreamersCommunitySingle(id) {
      const c = this;

      try {
          const response = await userService.getStreamersCommunityLeaderboardSingle(id);
       
          c.model.community = response.data;
          c.model.isLoggedIn = true;
          const fetchUserData = (team, index) => {
              return new Promise((resolve) => {
                  c.getCurrentTwitchInfo(c.model.community[index].user[0].twitchId, function(user) {
                      if (user) {
                          // Update the user object with the new Twitch data
                          team[index].user[0] = {
                              twitchId: user.twitchId,
                              twitchDisplayName: user.twitchDisplayName,
                              twitchProfileImage: user.twitchProfileImage
                          };
                      } else {
                          // If no user data is found, retain the existing user properties
                          team[index].user[0] = {
                              twitchId: team[index].user[0].twitchId,
                              twitchDisplayName: team[index].user[0].twitchDisplayName,
                              twitchProfileImage: team[index].user[0].twitchProfileImage
                          };
                      }
                      resolve();
                  });
              });
          };

          const userPromises = c.model.community.map((user, index) => fetchUserData(c.model.community, index));
          await Promise.all(userPromises);

          // Set the top users
          const first = c.model.community[0] || null;
          const second = c.model.community[1] || null;
          const third = c.model.community[2] || null;
          c.model.communityTop = [second, first, third];

      } catch (error) {
          console.log('Error fetching leaderboard faction:', error);
      }
        
    },
    showTab(tab){
      const c = this;
      c.model.tab = tab;
    },
    getSelectedTwitchInfo(data) {
      const c = this;
        c.getStreamersCommunitySingle(data);
        
        twitchAPI.getUsersById([{ twitchId: data }], function(userData) {
            if (userData.length > 0) {
                let d = userData[0]; // Get the first user from the response

                let user = {
                    twitchId: d.id,
                    twitchDisplayName: d.display_name,
                    twitchProfileImage: d.profile_image_url
                }

                c.model.selectedStreamer = user; 
            }
        });
    },
    getCurrentTeamTwitchInfo(udata, data, callback) {
      const c = this;
      return new Promise((resolve) => {
        twitchAPI.getUsersById([{ twitchId: data }], function(userData) {
          if (userData && userData.length > 0) {
            let user = {
              twitchId: userData[0].id,
              twitchDisplayName: userData[0].display_name,
              twitchProfileImage: userData[0].profile_image_url
            };
            callback(user); 
            resolve(user);
          } else {
          
            const defaultUser  = {
                twitchId: udata.twitchId, 
                twitchDisplayName: udata.twitchDisplayName,
                twitchProfileImage: udata.twitchProfileImage 
            };
            console.log(defaultUser)
            callback(defaultUser); 
            resolve(defaultUser); 
          }
        });
      });
    },
    async getSelectedOption(){
      const c = this;
      c.model.isLoggedIn = false
      if(c.model.selectedOption === '2v2'){
        c.model.memberCount = 2;
      }
      else if(c.model.selectedOption === '3v3'){
        c.model.memberCount = 3;
      }
      else if(c.model.selectedOption === '4v4'){
        c.model.memberCount = 4;
      }
      else{
        c.get();
        return;
      }
      
      try {
        const response = await userService.getSelectedTeamLeaderboard(c.model.selectedOption);
        c.model.teams = response.data;
      
        // Filter out teams with null or empty members
        c.model.teams = c.model.teams.filter(team => 
          team.members && team.members.length > 0 && 
          team.members.every(memberArray => memberArray && memberArray.length > 0)
        );

        // Create an array of promises for fetching Twitch user info
        const memberPromises = [];

        c.model.teams.forEach((team) => {
            team.members.forEach((memberArray, memberIndex) => {
                const member = memberArray[0];
                const promise = new Promise((resolve) => {
                    c.getCurrentTwitchInfo(member, member.twitchId, function(user) {
                        if (user) {
                            team.members[memberIndex] = {
                                ...member,
                                twitchDisplayName: user.twitchDisplayName,
                                twitchProfileImage: user.twitchProfileImage
                            };
                        }
                        resolve(); 
                    });
                });
                memberPromises.push(promise);
            });
        });

        await Promise.all(memberPromises);

        const first = c.model.teams[0] || null;
        const second = c.model.teams[1] || null;
        const third = c.model.teams[2] || null;
        c.model.top = [second, first, third];
        c.model.isLoggedIn = true;
      } catch (error) {
          console.error("Error fetching team leaderboard:", error);
      }

    }
  
  
  }
});